import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Notification, TextEditorFooter } from 'ui-components'
import { useSaveReadme } from '~map-preview/queries/useSaveReadme'
import { setReadme, useMap } from '~map-preview/states/map'
import { useMapNavStore } from '~map-preview/states/mapNav'

function Footer(props) {
  const { isOpenByDefault = false } = props
  const dispatch = useDispatch()
  const map = useMap()
  console.log('map', map)
  const { mutate } = useSaveReadme()
  const { setSideBar, setOpenDrawer } = useMapNavStore()

  const [loading, setLoading] = useState(false)
  const [saved, setSaved] = useState(false)

  const handleSubmit = (event, nodes) => {
    const currentNodes = map?.readme?.nodes

    dispatch(setReadme(nodes))
    setLoading(true)
    mutate(
      { mapId: map.id, nodes, isOpenByDefault },
      {
        onError: (error) => {
          dispatch(setReadme(currentNodes))
        },
        onSuccess: () => {
          setSaved(true)
          if (isOpenByDefault) setSideBar('info')
          else {
            setOpenDrawer(false)
            setSideBar('map')
          }
        },
        onSettled: () => {
          setLoading(false)
        }
      }
    )
  }

  const handleReadmeSnackClose = () => {
    setSaved(false)
  }

  return (
    <>
      <Notification
        position='bottom-right'
        variant='filled'
        severity='success'
        autoHideDuration={2500}
        open={saved}
        onClose={handleReadmeSnackClose}
      >
        Description saved!
      </Notification>

      <TextEditorFooter
        loading={loading}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export { Footer }
